import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type GQLError } from '@egw/clients'
import { notifications, NOTIFICATIONS } from '@egw/notifications'
import { getCustomerDetails } from '../../services'
import { type CustomerDetails } from '../../models'

/**
 * Customer Details state hook
 * @param options - tanstack useQuery options
 * @returns tanstack useQuery result, data is of type CustomerDetails
 */
export const useCustomerDetails = (
  options?: Omit<UseQueryOptions<CustomerDetails, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<CustomerDetails, GQLError> =>
  useQuery<CustomerDetails, GQLError>({
    queryKey: ['customerDetails'],
    queryFn: getCustomerDetails,
    select: (data: CustomerDetails): CustomerDetails => {
      // Dispatch notification whenever data is accessed (network or cache)
      notifications.dispatch(NOTIFICATIONS.API.CUSTOMER_DETAILS, {
        customer: {
          email: data.customer.email,
          firstName: data.customer.name.firstName,
          lastName: data.customer.name.lastName,
          phone: data.customer.phone.phoneNumber,
          dateOfBirth: data.customer.birthDate,
        },
        customerService: {
          tokens: {
            helpCenterToken: data.customerService.tokens.helpCenterToken,
            inAppChatToken: data.customerService.tokens.inAppChatToken,
          },
        },
      })
      return data
    },
    ...options,
  })
